module.exports = "/_next/static/images/loading_01-32ad8e2370c46b9a315427ccac6cf790.png";